import { render, staticRenderFns } from "./AteUnitTestingExer.vue?vue&type=template&id=385e7031"
import script from "./AteUnitTestingExer.vue?vue&type=script&lang=js"
export * from "./AteUnitTestingExer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports